export const environment = {
  production: true,
  urlBackend: 'https://admin.sismat.com.ar',
  endpointBackend: 'https://admin.sismat.com.ar/api',
  urlExternalGateway: 'https://backend.sismat.com.ar',
  n8nChatWebhookUrl: "https://n8n-production-5570.up.railway.app/webhook/055802b5-ea0a-47b9-8ea1-2b12735cb3db/chat",
  gaCode: 'G-5XC5TXZ4GX',
  sentry: {
    environment: "production",
    dsn: "https://b26e6760a9544a558bfd453a9b57d9c6@o1185465.ingest.us.sentry.io/6304064",
    release: 'SISMAT-20260619'
  }
};
